// components/filePreview/renderers/DocRenderer.tsx
import { useEffect, useState } from "react";
import mammoth from "mammoth";
import { Box, CircularProgress } from "@mui/material";

export const DocRenderer = ({ arrayBuffer }: { arrayBuffer: ArrayBuffer }) => {
  const [html, setHtml] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    mammoth
      .convertToHtml({ arrayBuffer })
      .then((result: { value: string }) => setHtml(result.value))
      .finally(() => setLoading(false));
  }, [arrayBuffer]);

  if (loading) return <CircularProgress />;

  return (
    <Box
      sx={{ maxHeight: "65vh", overflowY: "auto", px: 2, lineHeight: 1.8 }}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};